/**
 * Changes the sign in text based on the presence of a cookie.
 */
const updateSignInButton = (cookieVal) => {
  const signInButton = document.querySelector('.site-header__main__site-account-toggle__signin a');

  if (!signInButton) {
    return;
  }

  // if cookie val exists we want to change the sign in button to say 'sign out'
  if (cookieVal) {
    signInButton.innerHTML = 'Sign Out';
    signInButton.href = 'https://courses.edx.org/logout';
  }
};

/**
 * Get the url for the profile anchor and add the url to it.
 */
const getURL = async () => {
  // get cookies and split them into a list
  const cookies = document.cookie.split('; ');

  // the name of the cookie we're looking for
  const name = 'edx-jwt-cookie-header-payload=';

  // the value of the cookie we need
  let cookieVal = null;

  // loop through the list of cookies and find the needed cookie
  cookies.forEach((cookie) => {
    if (cookie.includes(name)) {
      // if we find the cookie, we get the value of it by stripping the name off of it
      const cookieVals = cookie.split(name);

      // check that there is a second part of the arr
      if (cookieVals.length === 2) {
        cookieVal = cookieVals[1]; // eslint-disable-line prefer-destructuring
      }
    }
  });

  // return if no cookie is found
  if (cookieVal === null) {
    return;
  }

  updateSignInButton(cookieVal);

  // split the cookir into the two different parts
  const payload = cookieVal.split('.');

  // Checking if both parts of the jwt ( header, payload ) are available, if they are
  // not the function is stopped as we need the payload to get the preffered user name
  if (payload.length !== 2) {
    return;
  }

  // get the payload of the jwt
  const base64Payload = payload[1];

  // make the payload base 64
  const base64 = base64Payload.replace(/-/g, '+').replace(/_/g, '/');

  // decode and json parse the encoded payload
  const jsonPayload = JSON.parse(
    decodeURIComponent(
      window
        .atob(base64)
        .split('')
        .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
        .join(''),
    ),
  );

  // set the link of the profile button
  const anchor = document.getElementById('cen-header-nav-profile-link');
  anchor.href = `https://courses.edx.org/u/${jsonPayload.preferred_username}`;
};

document.addEventListener('DOMContentLoaded', getURL);
